<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <router-link :to="{name: 'forum', params: {id: news.textParams[0]}}"
    >{{news.textParams[1]}}</router-link>
    {{$t('news.template.forum.displayedNameUpdated.p1')}}
    <router-link :to="{name: 'forum', params: {id: news.textParams[0]}}"
    >{{news.textParams[2]}}</router-link>
  </div>
</template>
